var _circle, _text, _circle2, _circle3, _text2, _text3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1469.443,
    height: 208.699,
    viewBox: "0 0 1469.443 208.699",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(569 5.699)",
    fill: "#e11a24"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_2.",
    "data-name": 2,
    transform: "translate(606 51.699)",
    fill: "#fff",
    fontSize: 42,
    fontFamily: "Raleway"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.162,
    y: 0
  }, "2."))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(0 5.699)",
    fill: "#e21923"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(1168 5.699)",
    fill: "#e11a24"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "_1.",
    "data-name": 1,
    transform: "translate(37 54.699)",
    fill: "#fff",
    fontSize: 42,
    fontFamily: "Raleway"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.957,
    y: 0
  }, "1."))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "_3.",
    "data-name": 3,
    transform: "translate(1205 54.699)",
    fill: "#fff",
    fontSize: 42,
    fontFamily: "Raleway"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.225,
    y: 0
  }, "3."))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 21,
    transform: "translate(461.5 148.199)",
    fill: "none",
    stroke: "#033f5b",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_148",
    "data-name": "Line 148",
    x2: 21,
    transform: "translate(368.5 148.199)",
    fill: "none",
    stroke: "#033f5b",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_151",
    "data-name": "Line 151",
    x2: 21,
    transform: "translate(337.5 148.199)",
    fill: "none",
    stroke: "#033f5b",
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 21,
    transform: "translate(1045.5 148.199)",
    fill: "none",
    stroke: "#033f5b",
    strokeWidth: 3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "Line_144",
    "data-name": "Line 144",
    x2: 21,
    transform: "translate(952.5 148.199)",
    fill: "none",
    stroke: "#033f5b",
    strokeWidth: 3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "Line_147",
    "data-name": "Line 147",
    x2: 21,
    transform: "translate(921.5 148.199)",
    fill: "none",
    stroke: "#033f5b",
    strokeWidth: 3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 21,
    transform: "translate(492.5 148.199)",
    fill: "none",
    stroke: "#033f5b",
    strokeWidth: 3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "Line_149",
    "data-name": "Line 149",
    x2: 21,
    transform: "translate(399.5 148.199)",
    fill: "none",
    stroke: "#033f5b",
    strokeWidth: 3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x2: 21,
    transform: "translate(1076.5 148.199)",
    fill: "none",
    stroke: "#033f5b",
    strokeWidth: 3
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    id: "Line_145",
    "data-name": "Line 145",
    x2: 21,
    transform: "translate(983.5 148.199)",
    fill: "none",
    stroke: "#033f5b",
    strokeWidth: 3
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 21,
    transform: "translate(523.5 148.199)",
    fill: "none",
    stroke: "#033f5b",
    strokeWidth: 3
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    id: "Line_150",
    "data-name": "Line 150",
    x2: 21,
    transform: "translate(430.5 148.199)",
    fill: "none",
    stroke: "#033f5b",
    strokeWidth: 3
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x2: 21,
    transform: "translate(1107.5 148.199)",
    fill: "none",
    stroke: "#033f5b",
    strokeWidth: 3
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    id: "Line_146",
    "data-name": "Line 146",
    x2: 21,
    transform: "translate(1014.5 148.199)",
    fill: "none",
    stroke: "#033f5b",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    d: "M6.136,1.481a1,1,0,0,1,1.728,0L13.123,10.5a1,1,0,0,1-.864,1.5H1.741a1,1,0,0,1-.864-1.5Z",
    transform: "translate(567 141.699) rotate(90)",
    fill: "#033f5b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3",
    "data-name": "Polygon 3",
    d: "M6.136,1.481a1,1,0,0,1,1.728,0L13.123,10.5a1,1,0,0,1-.864,1.5H1.741a1,1,0,0,1-.864-1.5Z",
    transform: "translate(1151 141.699) rotate(90)",
    fill: "#033f5b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "floor-plan_1_",
    "data-name": "floor-plan (1)",
    transform: "translate(78 28.699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M170.85,16H24.15A8.159,8.159,0,0,0,16,24.15v114.1a8.159,8.159,0,0,0,8.15,8.15H80.964L78.7,173.567H75.767V179h43.467v-5.433H116.3L114.036,146.4H170.85a8.159,8.159,0,0,0,8.15-8.15V24.15A8.159,8.159,0,0,0,170.85,16ZM21.433,24.15a2.72,2.72,0,0,1,2.717-2.717h146.7a2.72,2.72,0,0,1,2.717,2.717V124.667H21.433Zm89.414,149.417h-26.7L86.416,146.4h22.167Zm62.719-35.317a2.72,2.72,0,0,1-2.717,2.717H24.15a2.72,2.72,0,0,1-2.717-2.717V130.1H173.567Z",
    fill: "#033f5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M240.15,432.3a8.15,8.15,0,1,0-8.15-8.15A8.159,8.159,0,0,0,240.15,432.3Zm0-10.867a2.717,2.717,0,1,1-2.717,2.717A2.72,2.72,0,0,1,240.15,421.433Z",
    transform: "translate(-142.65 -264.167)",
    fill: "#033f5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M112.9,131.917h-5.433v8.15H69.433v-32.6H80.3v-5.433H69.433v-32.6h38.033v32.6H96.6v5.433h10.867v8.15H112.9V69.433h32.6V80.3h5.433V69.433h38.033v32.6H150.933V99.317H145.5v16.3h5.433v-8.15h38.033v2.717H194.4V66.717A2.717,2.717,0,0,0,191.683,64H66.717A2.717,2.717,0,0,0,64,66.717v76.067a2.717,2.717,0,0,0,2.717,2.717h89.65v-5.433H112.9Z",
    transform: "translate(-31.7 -31.7)",
    fill: "#033f5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M390.859,232.15l3.512-3.512A2.717,2.717,0,0,0,392.45,224H370.717A2.717,2.717,0,0,0,368,226.717V248.45a2.717,2.717,0,0,0,4.638,1.921l3.512-3.512L385.1,255.8a2.716,2.716,0,0,0,3.842,0L399.8,244.938a2.716,2.716,0,0,0,0-3.842Zm-3.842,17.891-8.946-8.946a2.716,2.716,0,0,0-3.842,0l-.8.8V229.433h12.458l-.8.8a2.716,2.716,0,0,0,0,3.842l8.946,8.946Z",
    transform: "translate(-232.467 -137.367)",
    fill: "#033f5b"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "office-block_1_",
    "data-name": "office-block (1)",
    transform: "translate(1202.323 141.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M182.317,134.467a3.283,3.283,0,0,0-.574.05,4.46,4.46,0,0,0-7.785,0,3.283,3.283,0,0,0-.574-.05,3.354,3.354,0,0,0-3.35,3.35,3.288,3.288,0,0,0,.207,1.117h-4.673v-6.7h5.583a1.117,1.117,0,0,0,1.117-1.117V86.451a1.117,1.117,0,0,0-1.117-1.117h-33.5a1.117,1.117,0,0,0-1.117,1.117v53.6a1.117,1.117,0,0,0,1.117,1.117h44.667a3.35,3.35,0,1,0,0-6.7Zm-16.75-46.9h4.467v6.7h-4.467Zm0,8.933h4.467v6.7h-4.467Zm0,8.933h4.467v6.7h-4.467Zm0,8.933h4.467v6.7h-4.467Zm0,8.933h4.467V130h-4.467Zm-22.333,15.633h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467V96.5h4.467Zm0-8.933h-4.467v-6.7h4.467Zm6.7,44.667h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467V96.5h4.467Zm0-8.933h-4.467v-6.7h4.467Zm6.7,44.667h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467V96.5h4.467Zm0-8.933h-4.467v-6.7h4.467Zm6.7,44.667h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467V96.5h4.467Zm0-8.933h-4.467v-6.7h4.467Zm18.983,44.667h-8.933a1.117,1.117,0,1,1,0-2.233,1.1,1.1,0,0,1,.605.182,1.117,1.117,0,0,0,1.693-.687,2.225,2.225,0,0,1,4.337,0,1.117,1.117,0,0,0,1.693.687,1.139,1.139,0,0,1,1.722.935A1.119,1.119,0,0,1,182.317,138.934Z",
    transform: "translate(-118.667 -74.167)",
    fill: "#033f5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M24.567,7.817V4.467h7.817A1.117,1.117,0,0,0,33.5,3.35V2.233h4.467V3.35a1.117,1.117,0,0,0,1.117,1.117H46.9V6.7H27.917a1.117,1.117,0,1,0,0,2.233H55.833V55.251a1.117,1.117,0,1,0,2.233,0V7.817A1.117,1.117,0,0,0,56.95,6.7H49.133V3.35a1.117,1.117,0,0,0-1.117-1.117H40.2V1.117A1.117,1.117,0,0,0,39.083,0h-6.7a1.117,1.117,0,0,0-1.117,1.117V2.233H23.45A1.117,1.117,0,0,0,22.333,3.35V6.7H14.517A1.117,1.117,0,0,0,13.4,7.816v56.95H6.7V60.187a5.593,5.593,0,0,0,4.467-5.471c0-.145-.064-14.517-5.583-14.517S0,54.571,0,54.717a5.593,5.593,0,0,0,4.467,5.471v4.579H1.117a1.117,1.117,0,0,0,0,2.233h13.4a1.117,1.117,0,0,0,1.117-1.117V8.933H23.45A1.117,1.117,0,0,0,24.567,7.817ZM2.233,54.717c0-5.563,1.494-12.283,3.35-12.283s3.35,6.72,3.35,12.283a3.35,3.35,0,0,1-6.7,0Z",
    transform: "translate(0)",
    fill: "#033f5b"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "office-block_1_2",
    "data-name": "office-block (1)",
    transform: "translate(1265.323 65.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_136-2",
    "data-name": "Group 136",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135-2",
    "data-name": "Group 135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272-2",
    "data-name": "Path 272",
    d: "M182.317,134.467a3.283,3.283,0,0,0-.574.05,4.46,4.46,0,0,0-7.785,0,3.283,3.283,0,0,0-.574-.05,3.354,3.354,0,0,0-3.35,3.35,3.288,3.288,0,0,0,.207,1.117h-4.673v-6.7h5.583a1.117,1.117,0,0,0,1.117-1.117V86.451a1.117,1.117,0,0,0-1.117-1.117h-33.5a1.117,1.117,0,0,0-1.117,1.117v53.6a1.117,1.117,0,0,0,1.117,1.117h44.667a3.35,3.35,0,1,0,0-6.7Zm-16.75-46.9h4.467v6.7h-4.467Zm0,8.933h4.467v6.7h-4.467Zm0,8.933h4.467v6.7h-4.467Zm0,8.933h4.467v6.7h-4.467Zm0,8.933h4.467V130h-4.467Zm-22.333,15.633h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467V96.5h4.467Zm0-8.933h-4.467v-6.7h4.467Zm6.7,44.667h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467V96.5h4.467Zm0-8.933h-4.467v-6.7h4.467Zm6.7,44.667h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467V96.5h4.467Zm0-8.933h-4.467v-6.7h4.467Zm6.7,44.667h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467V96.5h4.467Zm0-8.933h-4.467v-6.7h4.467Zm18.983,44.667h-8.933a1.117,1.117,0,1,1,0-2.233,1.1,1.1,0,0,1,.605.182,1.117,1.117,0,0,0,1.693-.687,2.225,2.225,0,0,1,4.337,0,1.117,1.117,0,0,0,1.693.687,1.139,1.139,0,0,1,1.722.935A1.119,1.119,0,0,1,182.317,138.934Z",
    transform: "translate(-118.667 -74.167)",
    fill: "#033f5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273-2",
    "data-name": "Path 273",
    d: "M24.567,7.817V4.467h7.817A1.117,1.117,0,0,0,33.5,3.35V2.233h4.467V3.35a1.117,1.117,0,0,0,1.117,1.117H46.9V6.7H27.917a1.117,1.117,0,1,0,0,2.233H55.833V55.251a1.117,1.117,0,1,0,2.233,0V7.817A1.117,1.117,0,0,0,56.95,6.7H49.133V3.35a1.117,1.117,0,0,0-1.117-1.117H40.2V1.117A1.117,1.117,0,0,0,39.083,0h-6.7a1.117,1.117,0,0,0-1.117,1.117V2.233H23.45A1.117,1.117,0,0,0,22.333,3.35V6.7H14.517A1.117,1.117,0,0,0,13.4,7.816v56.95H6.7V60.187a5.593,5.593,0,0,0,4.467-5.471c0-.145-.064-14.517-5.583-14.517S0,54.571,0,54.717a5.593,5.593,0,0,0,4.467,5.471v4.579H1.117a1.117,1.117,0,0,0,0,2.233h13.4a1.117,1.117,0,0,0,1.117-1.117V8.933H23.45A1.117,1.117,0,0,0,24.567,7.817ZM2.233,54.717c0-5.563,1.494-12.283,3.35-12.283s3.35,6.72,3.35,12.283a3.35,3.35,0,0,1-6.7,0Z",
    transform: "translate(0)",
    fill: "#033f5b"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "office-block_1_3",
    "data-name": "office-block (1)",
    transform: "translate(1299.323 141.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_136-3",
    "data-name": "Group 136",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135-3",
    "data-name": "Group 135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272-3",
    "data-name": "Path 272",
    d: "M182.317,134.467a3.283,3.283,0,0,0-.574.05,4.46,4.46,0,0,0-7.785,0,3.283,3.283,0,0,0-.574-.05,3.354,3.354,0,0,0-3.35,3.35,3.288,3.288,0,0,0,.207,1.117h-4.673v-6.7h5.583a1.117,1.117,0,0,0,1.117-1.117V86.451a1.117,1.117,0,0,0-1.117-1.117h-33.5a1.117,1.117,0,0,0-1.117,1.117v53.6a1.117,1.117,0,0,0,1.117,1.117h44.667a3.35,3.35,0,1,0,0-6.7Zm-16.75-46.9h4.467v6.7h-4.467Zm0,8.933h4.467v6.7h-4.467Zm0,8.933h4.467v6.7h-4.467Zm0,8.933h4.467v6.7h-4.467Zm0,8.933h4.467V130h-4.467Zm-22.333,15.633h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467V96.5h4.467Zm0-8.933h-4.467v-6.7h4.467Zm6.7,44.667h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467V96.5h4.467Zm0-8.933h-4.467v-6.7h4.467Zm6.7,44.667h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467V96.5h4.467Zm0-8.933h-4.467v-6.7h4.467Zm6.7,44.667h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467V96.5h4.467Zm0-8.933h-4.467v-6.7h4.467Zm18.983,44.667h-8.933a1.117,1.117,0,1,1,0-2.233,1.1,1.1,0,0,1,.605.182,1.117,1.117,0,0,0,1.693-.687,2.225,2.225,0,0,1,4.337,0,1.117,1.117,0,0,0,1.693.687,1.139,1.139,0,0,1,1.722.935A1.119,1.119,0,0,1,182.317,138.934Z",
    transform: "translate(-118.667 -74.167)",
    fill: "#033f5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273-3",
    "data-name": "Path 273",
    d: "M24.567,7.817V4.467h7.817A1.117,1.117,0,0,0,33.5,3.35V2.233h4.467V3.35a1.117,1.117,0,0,0,1.117,1.117H46.9V6.7H27.917a1.117,1.117,0,1,0,0,2.233H55.833V55.251a1.117,1.117,0,1,0,2.233,0V7.817A1.117,1.117,0,0,0,56.95,6.7H49.133V3.35a1.117,1.117,0,0,0-1.117-1.117H40.2V1.117A1.117,1.117,0,0,0,39.083,0h-6.7a1.117,1.117,0,0,0-1.117,1.117V2.233H23.45A1.117,1.117,0,0,0,22.333,3.35V6.7H14.517A1.117,1.117,0,0,0,13.4,7.816v56.95H6.7V60.187a5.593,5.593,0,0,0,4.467-5.471c0-.145-.064-14.517-5.583-14.517S0,54.571,0,54.717a5.593,5.593,0,0,0,4.467,5.471v4.579H1.117a1.117,1.117,0,0,0,0,2.233h13.4a1.117,1.117,0,0,0,1.117-1.117V8.933H23.45A1.117,1.117,0,0,0,24.567,7.817ZM2.233,54.717c0-5.563,1.494-12.283,3.35-12.283s3.35,6.72,3.35,12.283a3.35,3.35,0,0,1-6.7,0Z",
    transform: "translate(0)",
    fill: "#033f5b"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "office-block_1_4",
    "data-name": "office-block (1)",
    transform: "translate(1396.323 141.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_136-4",
    "data-name": "Group 136",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135-4",
    "data-name": "Group 135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272-4",
    "data-name": "Path 272",
    d: "M182.317,134.467a3.283,3.283,0,0,0-.574.05,4.46,4.46,0,0,0-7.785,0,3.283,3.283,0,0,0-.574-.05,3.354,3.354,0,0,0-3.35,3.35,3.288,3.288,0,0,0,.207,1.117h-4.673v-6.7h5.583a1.117,1.117,0,0,0,1.117-1.117V86.451a1.117,1.117,0,0,0-1.117-1.117h-33.5a1.117,1.117,0,0,0-1.117,1.117v53.6a1.117,1.117,0,0,0,1.117,1.117h44.667a3.35,3.35,0,1,0,0-6.7Zm-16.75-46.9h4.467v6.7h-4.467Zm0,8.933h4.467v6.7h-4.467Zm0,8.933h4.467v6.7h-4.467Zm0,8.933h4.467v6.7h-4.467Zm0,8.933h4.467V130h-4.467Zm-22.333,15.633h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467V96.5h4.467Zm0-8.933h-4.467v-6.7h4.467Zm6.7,44.667h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467V96.5h4.467Zm0-8.933h-4.467v-6.7h4.467Zm6.7,44.667h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467V96.5h4.467Zm0-8.933h-4.467v-6.7h4.467Zm6.7,44.667h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467V96.5h4.467Zm0-8.933h-4.467v-6.7h4.467Zm18.983,44.667h-8.933a1.117,1.117,0,1,1,0-2.233,1.1,1.1,0,0,1,.605.182,1.117,1.117,0,0,0,1.693-.687,2.225,2.225,0,0,1,4.337,0,1.117,1.117,0,0,0,1.693.687,1.139,1.139,0,0,1,1.722.935A1.119,1.119,0,0,1,182.317,138.934Z",
    transform: "translate(-118.667 -74.167)",
    fill: "#033f5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273-4",
    "data-name": "Path 273",
    d: "M24.567,7.817V4.467h7.817A1.117,1.117,0,0,0,33.5,3.35V2.233h4.467V3.35a1.117,1.117,0,0,0,1.117,1.117H46.9V6.7H27.917a1.117,1.117,0,1,0,0,2.233H55.833V55.251a1.117,1.117,0,1,0,2.233,0V7.817A1.117,1.117,0,0,0,56.95,6.7H49.133V3.35a1.117,1.117,0,0,0-1.117-1.117H40.2V1.117A1.117,1.117,0,0,0,39.083,0h-6.7a1.117,1.117,0,0,0-1.117,1.117V2.233H23.45A1.117,1.117,0,0,0,22.333,3.35V6.7H14.517A1.117,1.117,0,0,0,13.4,7.816v56.95H6.7V60.187a5.593,5.593,0,0,0,4.467-5.471c0-.145-.064-14.517-5.583-14.517S0,54.571,0,54.717a5.593,5.593,0,0,0,4.467,5.471v4.579H1.117a1.117,1.117,0,0,0,0,2.233h13.4a1.117,1.117,0,0,0,1.117-1.117V8.933H23.45A1.117,1.117,0,0,0,24.567,7.817ZM2.233,54.717c0-5.563,1.494-12.283,3.35-12.283s3.35,6.72,3.35,12.283a3.35,3.35,0,0,1-6.7,0Z",
    transform: "translate(0)",
    fill: "#033f5b"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "office-block_1_5",
    "data-name": "office-block (1)",
    transform: "translate(1363 65.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_136-5",
    "data-name": "Group 136",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135-5",
    "data-name": "Group 135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272-5",
    "data-name": "Path 272",
    d: "M182.317,134.467a3.283,3.283,0,0,0-.574.05,4.46,4.46,0,0,0-7.785,0,3.283,3.283,0,0,0-.574-.05,3.354,3.354,0,0,0-3.35,3.35,3.288,3.288,0,0,0,.207,1.117h-4.673v-6.7h5.583a1.117,1.117,0,0,0,1.117-1.117V86.451a1.117,1.117,0,0,0-1.117-1.117h-33.5a1.117,1.117,0,0,0-1.117,1.117v53.6a1.117,1.117,0,0,0,1.117,1.117h44.667a3.35,3.35,0,1,0,0-6.7Zm-16.75-46.9h4.467v6.7h-4.467Zm0,8.933h4.467v6.7h-4.467Zm0,8.933h4.467v6.7h-4.467Zm0,8.933h4.467v6.7h-4.467Zm0,8.933h4.467V130h-4.467Zm-22.333,15.633h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467V96.5h4.467Zm0-8.933h-4.467v-6.7h4.467Zm6.7,44.667h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467V96.5h4.467Zm0-8.933h-4.467v-6.7h4.467Zm6.7,44.667h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467V96.5h4.467Zm0-8.933h-4.467v-6.7h4.467Zm6.7,44.667h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467v-6.7h4.467Zm0-8.933h-4.467V96.5h4.467Zm0-8.933h-4.467v-6.7h4.467Zm18.983,44.667h-8.933a1.117,1.117,0,1,1,0-2.233,1.1,1.1,0,0,1,.605.182,1.117,1.117,0,0,0,1.693-.687,2.225,2.225,0,0,1,4.337,0,1.117,1.117,0,0,0,1.693.687,1.139,1.139,0,0,1,1.722.935A1.119,1.119,0,0,1,182.317,138.934Z",
    transform: "translate(-118.667 -74.167)",
    fill: "#033f5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273-5",
    "data-name": "Path 273",
    d: "M24.567,7.817V4.467h7.817A1.117,1.117,0,0,0,33.5,3.35V2.233h4.467V3.35a1.117,1.117,0,0,0,1.117,1.117H46.9V6.7H27.917a1.117,1.117,0,1,0,0,2.233H55.833V55.251a1.117,1.117,0,1,0,2.233,0V7.817A1.117,1.117,0,0,0,56.95,6.7H49.133V3.35a1.117,1.117,0,0,0-1.117-1.117H40.2V1.117A1.117,1.117,0,0,0,39.083,0h-6.7a1.117,1.117,0,0,0-1.117,1.117V2.233H23.45A1.117,1.117,0,0,0,22.333,3.35V6.7H14.517A1.117,1.117,0,0,0,13.4,7.816v56.95H6.7V60.187a5.593,5.593,0,0,0,4.467-5.471c0-.145-.064-14.517-5.583-14.517S0,54.571,0,54.717a5.593,5.593,0,0,0,4.467,5.471v4.579H1.117a1.117,1.117,0,0,0,0,2.233h13.4a1.117,1.117,0,0,0,1.117-1.117V8.933H23.45A1.117,1.117,0,0,0,24.567,7.817ZM2.233,54.717c0-5.563,1.494-12.283,3.35-12.283s3.35,6.72,3.35,12.283a3.35,3.35,0,0,1-6.7,0Z",
    transform: "translate(0)",
    fill: "#033f5b"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "conversation",
    transform: "translate(1262.515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(0 21.14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M42.037,191.617a1.215,1.215,0,0,0-1.215,1.215v8.383a6.082,6.082,0,0,1-6.075,6.075H21.63a1.215,1.215,0,0,0-1.215,1.214l0,2.416-2.9-2.9a1.215,1.215,0,0,0-1.114-.73H8.5a6.082,6.082,0,0,1-6.075-6.075V182.5A6.082,6.082,0,0,1,8.5,176.43H20.776a1.215,1.215,0,1,0,0-2.43H8.5A8.514,8.514,0,0,0,0,182.5v18.71a8.514,8.514,0,0,0,8.5,8.5h7.272l4.99,4.99a1.215,1.215,0,0,0,2.074-.858l0-4.132h11.9a8.514,8.514,0,0,0,8.5-8.5v-8.383A1.215,1.215,0,0,0,42.037,191.617Z",
    transform: "translate(0 -174)",
    fill: "#033f5b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(23.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M216.734,0h-3.075a17.659,17.659,0,1,0,0,35.317h3.075a17.693,17.693,0,0,0,4.482-.575l4.542,4.54a1.215,1.215,0,0,0,2.074-.859V31.394a17.827,17.827,0,0,0,4.642-5.723,17.468,17.468,0,0,0,1.919-8.013A17.679,17.679,0,0,0,216.734,0Zm9.152,29.831a1.215,1.215,0,0,0-.484.97v4.69l-2.973-2.972a1.214,1.214,0,0,0-1.216-.3,15.233,15.233,0,0,1-4.479.67h-3.075a15.229,15.229,0,1,1,0-30.458h3.075a15.229,15.229,0,0,1,9.152,27.4Z",
    transform: "translate(-196)",
    fill: "#033f5b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(38.206 8.512)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M324.737,74.845a5.155,5.155,0,0,0-4.769-4.769,5.1,5.1,0,0,0-3.871,1.371,5.162,5.162,0,0,0-1.634,3.761,1.215,1.215,0,0,0,2.43,0A2.714,2.714,0,0,1,319.8,72.5a2.714,2.714,0,0,1,.4,5.355,2.3,2.3,0,0,0-1.811,2.254v2.919a1.215,1.215,0,1,0,2.43,0V80.206A5.117,5.117,0,0,0,324.737,74.845Z",
    transform: "translate(-314.462 -70.063)",
    fill: "#033f5b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(42.134 25.068)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M348.874,206.686a1.216,1.216,0,1,0,.356.859A1.224,1.224,0,0,0,348.874,206.686Z",
    transform: "translate(-346.8 -206.33)",
    fill: "#033f5b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(6.561 37.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M80.85,310H55.215a1.215,1.215,0,0,0,0,2.43H80.85a1.215,1.215,0,0,0,0-2.43Z",
    transform: "translate(-54 -310)",
    fill: "#033f5b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    transform: "translate(32.196 44.467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M267.074,366.356a1.214,1.214,0,1,0,.356.859A1.224,1.224,0,0,0,267.074,366.356Z",
    transform: "translate(-265 -366)",
    fill: "#033f5b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(6.561 44.467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M76.072,366H55.215a1.215,1.215,0,1,0,0,2.43H76.072a1.215,1.215,0,1,0,0-2.43Z",
    transform: "translate(-54 -366)",
    fill: "#033f5b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(6.561 30.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M72.953,254H55.215a1.215,1.215,0,1,0,0,2.43H72.953a1.215,1.215,0,1,0,0-2.43Z",
    transform: "translate(-54 -254)",
    fill: "#033f5b"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "speech-bubble",
    transform: "translate(1406 5.699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M247.239,100a1.239,1.239,0,1,0,1.239,1.239A1.24,1.24,0,0,0,247.239,100Zm0,0",
    transform: "translate(-215.517 -87.609)",
    fill: "#033f5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M81.239,262.478A1.239,1.239,0,1,0,80,261.239,1.24,1.24,0,0,0,81.239,262.478Zm0,0",
    transform: "translate(-70.087 -227.783)",
    fill: "#033f5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M41.635,0C30.479,0,21.323,7.691,20.615,17.379,9.991,17.912,0,25.573,0,35.935a17.315,17.315,0,0,0,4.833,11.85,7.536,7.536,0,0,1-1.991,7.1A1.239,1.239,0,0,0,3.717,57a13.669,13.669,0,0,0,9.47-3.828,28.238,28.238,0,0,0,8.621,1.349c11.154,0,20.309-7.689,21.019-17.375a27.864,27.864,0,0,0,7.428-1.322,13.668,13.668,0,0,0,9.47,3.828,1.239,1.239,0,0,0,.876-2.115,7.536,7.536,0,0,1-1.991-7.1,17.315,17.315,0,0,0,4.833-11.85C63.443,7.821,52.683,0,41.635,0ZM21.809,52.043a25.049,25.049,0,0,1-8.489-1.462,1.239,1.239,0,0,0-1.373.315,11.181,11.181,0,0,1-5.561,3.3,10.021,10.021,0,0,0,.756-7.375,1.237,1.237,0,0,0-.3-.524,14.891,14.891,0,0,1-4.36-10.362c0-8.732,8.852-16.109,19.33-16.109,9.895,0,18.587,6.881,18.587,16.109C40.4,44.817,32.058,52.043,21.809,52.043Zm34.8-23.094a1.243,1.243,0,0,0-.3.524,10.021,10.021,0,0,0,.756,7.375,11.177,11.177,0,0,1-5.561-3.3,1.24,1.24,0,0,0-1.373-.315,24.41,24.41,0,0,1-7.3,1.431,17.737,17.737,0,0,0-6.7-12.36H52.291a1.239,1.239,0,0,0,0-2.478H32.321A23.11,23.11,0,0,0,23.1,17.384c.712-8.323,8.753-14.906,18.535-14.906,10.478,0,19.33,7.377,19.33,16.109A14.891,14.891,0,0,1,56.606,28.949Zm0,0",
    fill: "#033f5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M136.852,260H121.239a1.239,1.239,0,0,0,0,2.478h15.613a1.239,1.239,0,0,0,0-2.478Zm0,0",
    transform: "translate(-105.13 -227.783)",
    fill: "#033f5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M101.809,320H81.239a1.239,1.239,0,0,0,0,2.478h20.57a1.239,1.239,0,0,0,0-2.478Zm0,0",
    transform: "translate(-70.087 -280.348)",
    fill: "#033f5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M302.852,100H287.239a1.239,1.239,0,1,0,0,2.478h15.613a1.239,1.239,0,1,0,0-2.478Zm0,0",
    transform: "translate(-250.561 -87.609)",
    fill: "#033f5b"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "chatbot_5705176",
    transform: "translate(670.487 22.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573",
    transform: "translate(71.109 39.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M296.584,74.414H274.308a2.781,2.781,0,0,1,0-5.562h22.276a2.781,2.781,0,1,1,0,5.562Zm-36.181,0h-6.393a2.781,2.781,0,0,1,0-5.562H260.4a2.781,2.781,0,1,1,0,5.562Z",
    transform: "translate(-251.23 -68.852)",
    fill: "#033f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_574",
    "data-name": "Group 574",
    transform: "translate(71.109 51.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M296.584,119.683H254.011a2.781,2.781,0,0,1,0-5.562h42.573a2.781,2.781,0,1,1,0,5.562Z",
    transform: "translate(-251.23 -114.121)",
    fill: "#033f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_575",
    "data-name": "Group 575",
    transform: "translate(71.109 64.433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M296.584,164.923h-6.393a2.781,2.781,0,1,1,0-5.562h6.393a2.781,2.781,0,1,1,0,5.562Zm-20.3,0H254.011a2.781,2.781,0,0,1,0-5.562h22.276a2.781,2.781,0,1,1,0,5.562Z",
    transform: "translate(-251.23 -159.361)",
    fill: "#033f5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576",
    transform: "translate(6.324 39.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M144.38,271.61c-5.775,0-10.474,5.664-10.474,12.626s4.7,12.626,10.474,12.626,10.466-5.664,10.466-12.626S150.151,271.61,144.38,271.61Zm0,19.69c-2.663,0-4.913-3.235-4.913-7.064s2.25-7.064,4.913-7.064,4.9,3.235,4.9,7.064S147.039,291.3,144.38,291.3Z",
    transform: "translate(-96.669 -202.639)",
    fill: "#033f5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M233.785,396.44a8.746,8.746,0,0,1-12.388,0,2.781,2.781,0,0,0-3.936,3.929,14.308,14.308,0,0,0,20.26,0,2.781,2.781,0,0,0-3.936-3.929Z",
    transform: "translate(-156.402 -292.167)",
    fill: "#033f5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M127.655,87.881h-5.5a42.721,42.721,0,0,0-6.821-8.39h7.386a9.365,9.365,0,0,0,9.355-9.355v-37.2a9.365,9.365,0,0,0-9.355-9.355H65.139a9.366,9.366,0,0,0-9.355,9.355V67.655A42.619,42.619,0,0,0,20.219,87.881H17.5V53.07a11.642,11.642,0,1,0-5.562,0V88.148A14.737,14.737,0,0,0,0,102.6v15.3A14.732,14.732,0,0,0,14.715,132.61h5.5a42.615,42.615,0,0,0,36.245,20.234H85.917a42.3,42.3,0,0,0,30.089-12.51,43.236,43.236,0,0,0,6.141-7.724h5.508A14.736,14.736,0,0,0,142.378,117.9V102.6a14.736,14.736,0,0,0-14.723-14.715ZM8.636,41.759a6.083,6.083,0,1,1,6.079,6.087A6.086,6.086,0,0,1,8.636,41.759Zm8.678,85.29h-2.6A9.164,9.164,0,0,1,5.561,117.9V102.6a9.164,9.164,0,0,1,9.153-9.153h2.6a42.553,42.553,0,0,0,0,33.606Zm44.032-94.11a3.8,3.8,0,0,1,3.793-3.793H122.72a3.8,3.8,0,0,1,3.793,3.793v37.2a3.8,3.8,0,0,1-3.793,3.793H93.114a2.781,2.781,0,0,0-2.374,1.332c-5.473,8.966-10.157,10.68-17.465,12.649a27.682,27.682,0,0,0,1.786-11.247,2.781,2.781,0,0,0-2.781-2.734H65.139a3.8,3.8,0,0,1-3.793-3.793v-37.2ZM85.917,147.283H56.46a37.037,37.037,0,0,1-.155-74.073,9.369,9.369,0,0,0,8.833,6.28h4.314C69.2,83.934,68,86.393,65.8,90.929a2.78,2.78,0,0,0,3.273,3.886c1.44-.416,2.806-.779,4.128-1.13,8.2-2.175,14.743-3.912,21.447-14.2h11.831a37,37,0,0,1-20.562,67.793Zm50.9-29.388a9.167,9.167,0,0,1-9.161,9.153H125.06a42.544,42.544,0,0,0,0-33.606h2.593a9.167,9.167,0,0,1,9.161,9.153v15.3Z",
    transform: "translate(0 -23.584)",
    fill: "#033f5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M313.236,271.61c-5.776,0-10.474,5.664-10.474,12.626s4.7,12.626,10.474,12.626S323.7,291.2,323.7,284.236,319.008,271.61,313.236,271.61Zm0,19.69c-2.663,0-4.913-3.235-4.913-7.064s2.25-7.064,4.913-7.064,4.9,3.235,4.9,7.064S315.895,291.3,313.236,291.3Z",
    transform: "translate(-218.57 -202.639)",
    fill: "#033f5b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess);
export default __webpack_public_path__ + "static/media/process.ccdedf3a9c4b5c0cba4b229a90b885e8.svg";
export { ForwardRef as ReactComponent };